import { styled } from 'linaria/react';

const StyledLoader = styled.div<{ isFullScreen?: boolean; isCentered?: boolean }>`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: ${({ isFullScreen, isCentered }) => (isFullScreen || isCentered ? 'calc(100dvh - 68px)' : 'auto')};
  padding: ${({ isFullScreen, isCentered }) => (isFullScreen || isCentered ? 0 : 0)}px 0;
  width: 100%;
  margin: ${({ isCentered }) => (isCentered ? 'auto' : 0)};
`;

export default StyledLoader;
